import { render, staticRenderFns } from "./AttestationReportList.vue?vue&type=template&id=4c32195e&scoped=true&"
import script from "./AttestationReportList.vue?vue&type=script&lang=js&"
export * from "./AttestationReportList.vue?vue&type=script&lang=js&"
import style0 from "./AttestationReportList.vue?vue&type=style&index=0&id=4c32195e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c32195e",
  null
  
)

export default component.exports